import './sort-selector.scss'

import { defineComponent, PropType } from 'vue';
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons';

import { SORT_ORDER_CHANGED, SORT_SELECTED } from '../../events';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";

export const SortSelector = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        options: {
            type: Array as PropType<string[]>,
            default: [],
        },
        placeholder: {
            type: String,
            default: 'sortSelector.placeholder'
        },
    },
    template: require('./sort-selector.html'),
    data() {
        return {
            selected: null as string | null,
            sortAscending: true,

            sortAscIcon: faSortAmountUp,
            sortDescIcon: faSortAmountDown,
        }
    },
    computed: {
        computedPlaceholder(): string {
            return this.$t(this.placeholder as string) as string ?? this.placeholder
        },
    },
    methods: {
        onSelectedValueChanged(value: string) {
            this.$emit(SORT_SELECTED, value)
        },
        toggleSortAscending() {
            this.sortAscending = !this.sortAscending
            this.$emit(SORT_ORDER_CHANGED, this.sortAscending)
        },
    },
})
